import React from 'react'
import './Header.css';
function Header
() {
  return (
    <h2>
        Expense tracker
    </h2>
  )
}

export default Header
